import React from 'react';
import { HdLink } from '../../../components';
import {
  BILLING_CYCLE_MIGRATION_BANNER_MESSAGE,
  BILLING_CYCLE_MIGRATION_LEARN_MORE_URL
} from '../../constants/strings';

export default function BillingCycleMigrationBannerMessage() {
  return (
    <>
      {BILLING_CYCLE_MIGRATION_BANNER_MESSAGE}{' '}
      <HdLink
        dataId='billing-cycle-migration-banner-learn-more'
        color='light'
        href={BILLING_CYCLE_MIGRATION_LEARN_MORE_URL}
        target='_blank'
        icon='new-window'
      >
        Learn more
      </HdLink>
    </>
  );
}
